/**
 * Hierarchy Service
 *
 * API client for the Product Hierarchy Link Manager.
 */

import axios from 'axios';

const apiClient = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('okta-token-storage');
    if (raw) {
      const accessToken = JSON.parse(raw)?.accessToken?.accessToken;
      if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    }
  } catch {
    // ignore — request proceeds without auth header
  }
  return config;
});

const hierarchyService = {
  getPackages: () => apiClient.get('/api/hierarchy/packages'),

  getAllCommercialProducts: () => apiClient.get('/api/hierarchy/commercial-products'),

  getCommercialProductsForPackage: (packageId) =>
    apiClient.get(`/api/hierarchy/packages/${packageId}/commercial-products`),

  linkCommercial: (packageId, commercialId) =>
    apiClient.post(`/api/hierarchy/packages/${packageId}/link/${commercialId}`),

  unlinkCommercial: (packageId, commercialId) =>
    apiClient.delete(`/api/hierarchy/packages/${packageId}/link/${commercialId}`),

  getTechnicalProductsForCommercial: (commercialId) =>
    apiClient.get(`/api/hierarchy/commercial-products/${commercialId}/technical-products`),

  saveTechnicalLinks: (commercialId, technicalProductIds) =>
    apiClient.post(`/api/hierarchy/commercial-products/${commercialId}/technical-products`, {
      technicalProductIds,
    }),

  getCommercialProductsForTechnical: (technicalId) =>
    apiClient.get(`/api/hierarchy/technical-products/${technicalId}/commercial-products`),

  getPackagesForCommercial: (commercialId) =>
    apiClient.get(`/api/hierarchy/commercial-products/${commercialId}/packages`),
};

export default hierarchyService;
